import { render, staticRenderFns } from "./MATAddModal.vue?vue&type=template&id=4182f60d&scoped=true"
import script from "./MATAddModal.vue?vue&type=script&lang=js"
export * from "./MATAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4182f60d",
  null
  
)

export default component.exports